import { render, staticRenderFns } from "./UserConsume.vue?vue&type=template&id=44a7e1ec&scoped=true&"
import script from "./UserConsume.vue?vue&type=script&lang=js&"
export * from "./UserConsume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a7e1ec",
  null
  
)

export default component.exports